"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFakeOffer = void 0;
const faker_1 = __importDefault(require("@faker-js/faker"));
const lodash_1 = require("lodash");
faker_1.default.seed(718);
const generateFakeOffer = (overrides = {}) => {
    const productDisplayName = faker_1.default.commerce.product();
    const productType = (0, lodash_1.upperFirst)((0, lodash_1.camelCase)(productDisplayName));
    const demandSubAccountName = faker_1.default.company.companyName();
    const defaultOffer = {
        createdAt: faker_1.default.date.recent().toISOString(),
        currentVersion: 1,
        demandSubAccountDisplayName: demandSubAccountName,
        demandSubAccountImageUrl: faker_1.default.image.imageUrl(),
        demandSubAccountName,
        demandSubAccountUuid: faker_1.default.datatype.uuid(),
        internalName: faker_1.default.commerce.productName(),
        keywords: Array(5)
            .fill('')
            .map(() => faker_1.default.lorem.word(10)),
        monetizedUrl: faker_1.default.internet.url(),
        productDisplayName,
        productType,
        productVersions: [2],
        status: 'active',
        tags: {
            tag1: 'value1',
            tag2: 'value2',
            tag3: 'value3',
        },
        unmonetizedUrl: faker_1.default.internet.url(),
        updatedAt: faker_1.default.date.recent().toISOString(),
        uuid: faker_1.default.datatype.uuid(),
        version: 1,
    };
    return Object.assign(Object.assign({}, defaultOffer), overrides);
};
exports.generateFakeOffer = generateFakeOffer;
